import { render, staticRenderFns } from "./statement-import-single-details.vue?vue&type=template&id=7b015334&scoped=true"
import script from "./statement-import-single-details.vue?vue&type=script&lang=ts"
export * from "./statement-import-single-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b015334",
  null
  
)

export default component.exports